// TODO: https://github.com/angular/angular/issues/18261
import { HttpParameterCodec } from '@angular/common/http';

export class CustomQueryEncoderHelper implements HttpParameterCodec {
  encodeKey(k: string): string {
    return k.replace(/\+/gi, '%2B');
  }

  encodeValue(v: string): string {
    return v.replace(/\+/gi, '%2B');
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}
